module.exports = __webpack_public_path__ + "img/17.ffe908d8.png";